import {
  ACT_TYPE_AGENT_REWARD_BOX,
  ACT_TYPE_FIRST_DEPOSIT_REWARD,
  ACT_TYPE_LINK,
  ACT_TYPE_LOSS_CASHBACK,
  ACT_TYPE_RED_ENVELOPE_RAIN,
  ACT_TYPE_SIGN_IN,
  ACT_TYPE_SPIN_LUCK,
  ACT_TYPE_TOTAL_DEPOSIT_REWARD,
} from './types'
import { spinLuckModule } from './spinLuck/module'
import { redEnvelopeRainModule } from './redEnvelopeRain/module'
import { signInModule } from './signIn/module'
import { linkModule } from './link/module'
import { agentRewardBoxModule } from './agentRewardBox/module'
import { lossCashbackModule } from './lossCashback/module'
import { totalDepositRewardModule } from './totalDepositReward/module'
import { firstDepositRewardModule } from './firstDepositReward/module'

const modules = [
  spinLuckModule,
  redEnvelopeRainModule,
  signInModule,
  agentRewardBoxModule,
  lossCashbackModule,
  totalDepositRewardModule,
  firstDepositRewardModule,
  linkModule,
]

const moduleMap = modules.reduce((acc, m) => {
  acc[m.type] = m
  return acc
}, {})

export function getActivityTypeModule(type) {
  return moduleMap[type] || moduleMap[ACT_TYPE_SPIN_LUCK]
}

export function getAllActivityTypeModules() {
  return modules.slice()
}

export {
  ACT_TYPE_SPIN_LUCK,
  ACT_TYPE_RED_ENVELOPE_RAIN,
  ACT_TYPE_SIGN_IN,
  ACT_TYPE_AGENT_REWARD_BOX,
  ACT_TYPE_LOSS_CASHBACK,
  ACT_TYPE_TOTAL_DEPOSIT_REWARD,
  ACT_TYPE_FIRST_DEPOSIT_REWARD,
  ACT_TYPE_LINK,
}

